// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"36":"b8054a9a","202":"b23919d1","222":"c7ab5c26","241":"6fdf1c85","289":"6fdf1c85","769":"2b56325d","934":"6fdf1c85"}[chunkId] + ".chunk.css";
};